import moment from "moment";

export function ReadableDateTime(dateTime, includeSeconds=true) {
  if (!dateTime) return "Invalid Date"
  let momTime = moment(dateTime);
  if (momTime.isValid()) {
    let formatString = includeSeconds ? "MM/DD/YYYY HH:mm:ss" : "MM/DD/YYYY HH:mm"
    return momTime.format(formatString);
    // return momTime.format("MM/DD/YYYY HH:mm:ss");
  } else {
    return "Invalid Date";
  }
}

export function ReadableLocalDateTime(dateTime, includeSeconds=true) {
  if (!dateTime) return "Invalid Date"
  let momTime = moment(dateTime);
  if (momTime.isValid()) {
    momTime = momTime.local();
    let formatString = includeSeconds ? "MM/DD/YYYY HH:mm:ss" : "MM/DD/YYYY HH:mm"
    return momTime.format(formatString);
  } else {
    return "Invalid Date";
  }
}

export function GetPeriodFromMomentTime(time) {
  if (time && moment.isMoment(time)) {
    let period = time.hour() * 2;
    if (time.minute() > 29) {
      period += 1;
    }
    console.log(period);
    return period;
  }
}

export function SetTimeToHalfHour(time) {
  if (time && moment.isMoment(time)) {
    if (time.minute() >= 30) {
      time.minute(30);
    } else {
      time.minute(0);
    }
  }
}

export function SortByTime(timeA, timeB, ascending){
  let dateA = moment(timeA);
  let dateB = moment(timeB);
  if (!dateA.isValid()){
    return -1;
  }
  if (!dateB.isValid()){
    return 1;
  }
  // console.log(dateA, dateB, ascending);
  if (ascending){
    return dateA.diff(dateB);
  }else{
    return dateB.diff(dateA);
  }
}
